import type { PokerRelatedEvents } from '@ps/web-martech-cms-types';
import { useTrackers } from '@ps/web-shared-analytics';
import classNames from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import ArrowFilter from '../../assets/Arrow.svg';
import powerpath from '../../assets/pkr_powerpath_square.png';
import satellite from '../../assets/pkr_satellite_square.png';
import spinandgo from '../../assets/pkr_spinandgo_square.png';
import { usePokerSundayMillionWidget } from '../../model';
import { SundayMillionTab } from '../../types';

import {
  TXTCLI_N0_buy_inX_fast_paceX_N1_playe_ELL,
  TXTCLI_Satellites_from_just_N0,
  TXTCLI_Win_an_entry_for_as_little_as__ELL
} from './Tile.messages.json';
import styles from './Tile.scss';
import type { TileTranslationProps } from './TileTranslation';
import TileTranslation from './TileTranslation';

const TILE_TYPE_IMAGE_MAP: {
  [key in PokerRelatedEvents['type']]: {
    image: string;
    enabled: TileTranslationProps;
  };
} = {
  Satellites: {
    image: satellite,
    enabled: { translation: TXTCLI_Satellites_from_just_N0 }
  },
  'Spin & Go': {
    image: spinandgo,
    enabled: { translation: TXTCLI_N0_buy_inX_fast_paceX_N1_playe_ELL, numberOfPlay: 3 }
  },
  'Power Path': {
    image: powerpath,
    enabled: { translation: TXTCLI_Win_an_entry_for_as_little_as__ELL }
  }
};
export interface TileProps {
  event: PokerRelatedEvents;
  rect?: boolean;
}

const Tile: React.FC<TileProps> = ({ event, rect = false }) => {
  const { type, value } = event;
  const { widgetDispatch } = usePokerSundayMillionWidget();
  const isEmbedded = useSelector(select.device.isDesktopEmbedded);
  const { linkClicked } = useTrackers();

  const handleClick = () => {
    if (type === 'Satellites') {
      linkClicked({ destinationUrl: SundayMillionTab.Satellites });
      widgetDispatch.changeTab({ tab: SundayMillionTab.Satellites });
      return;
    }
    if (!isEmbedded) return;
    linkClicked({ destinationUrl: event.path });
    window.starsweb?.app?.execute(event.path);
  };

  return (
    <div
      className={classNames(styles.root, {
        [styles.rectangular]: rect
      })}
      onClick={handleClick}
    >
      <div className={styles.container}>
        <picture className={styles.imageContainer}>
          <img src={TILE_TYPE_IMAGE_MAP[type].image} alt={`Sunday Million Tile ${type}`} />
        </picture>
        <div className={styles.content}>
          <TileTranslation {...TILE_TYPE_IMAGE_MAP[type].enabled} value={value} />
        </div>
      </div>
      {!rect && (
        <div className={styles.arrowContainer}>
          <div className={styles.arrow} />
          <ArrowFilter className={styles.arrowSvg} />
        </div>
      )}
    </div>
  );
};

export default Tile;
